<template>
  <div id="orderSearch">
    <el-form :inline="true" :model="searchForm">
      <el-form-item label="下单时间">
        <el-date-picker
          style="width: 250px"
          size="mini"
          v-model="searchForm.createTimeRange"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="搜索类型">
        <el-select style="width: 100px" size="mini" v-model="searchForm.searchType" placeholder="请选择">
          <el-option
            v-for="item in searchTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input
          size="mini"
          placeholder="搜索关键字"
          prefix-icon="el-icon-search"
          v-model="searchForm.keyWords">
        </el-input>
      </el-form-item>
      <el-form-item label="剩余有效期">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-input
              size="mini"
              type="number"
              placeholder="请输入最低天数"
              v-model="searchForm.minValidDays">
            </el-input>
          </el-col>
          <el-col :span="12">
            <el-input
              size="mini"
              type="number"
              placeholder="请输入最高天数"
              v-model="searchForm.maxValidDays">
            </el-input>
          </el-col>
        </el-row>


      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" @click="getData()">搜索</el-button>
        <el-button type="primary" size="mini" @click="exportAll(null)">导出excel</el-button>
        <el-button size="mini" @click="exportImg">导出图片</el-button>
      </el-form-item>
    </el-form>
    <el-button-group>
      <el-button :type="status == 0? 'primary' : ''" @click="selectOrderStatus(0)">全部</el-button>
      <el-button :type="status == 1? 'primary' : ''" @click="selectOrderStatus(1)">待审核</el-button>
      <el-button :type="status == 5? 'primary' : ''" @click="selectOrderStatus(5)">审核通过</el-button>
      <el-button :type="status == 4? 'primary' : ''" @click="selectOrderStatus(4)">已驳回</el-button>
    </el-button-group>
    <el-table
      max-height="500px"
      :data="tableData"
      style="width: 100%"
      @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column type="index" label="NO" width="60">
        <template slot-scope="scope">
          <img v-if="scope.row.messageContentList.length > 0 && scope.row.messageBackList.length <= 0" src="../assets/message_new.png"
               style="height: 20px;vertical-align: middle" @click="showMessage(scope.row)">
          <img v-if="scope.row.messageContentList.length > 0 && scope.row.messageBackList.length > 0" src="../assets/message_old.png"
               style="height: 20px;vertical-align: middle" @click="showMessage(scope.row)">
          {{scope.$index+1}}
        </template>
      </el-table-column>
      <el-table-column prop="sellerHeadPic" label="头像">
        <template slot-scope="scope">
          <el-avatar size="small" :src="scope.row.sellerHeadPic?scope.row.sellerHeadPic:defaultHeadPicSrc"></el-avatar>
        </template>
      </el-table-column>
      <el-table-column prop="orderNum" label="订单号" show-overflow-tooltip></el-table-column>
      <el-table-column prop="cardName" label="商品名" show-overflow-tooltip></el-table-column>
      <el-table-column prop="cardUnqiueNum" label="卡券号" show-overflow-tooltip></el-table-column>
      <el-table-column prop="validDate" label="有效期" show-overflow-tooltip>
        <template slot-scope="scope">
          <span :style="new Date().getTime() > new Date(scope.row.validDate).getTime()?'color:red':''">
            {{dateFormatter2(null,null,scope.row.validDate)}}
          </span>
          <span style="color:red"></span>
        </template>
      </el-table-column>
      <el-table-column prop="payMoney" label="应付金额"></el-table-column>
      <el-table-column prop="sellerName" label="微信昵称" show-overflow-tooltip></el-table-column>
      <el-table-column prop="operaterName" label="操作人员"></el-table-column>
      <el-table-column prop="status" label="订单状态"></el-table-column>
      <el-table-column prop="createTime" :formatter="dateFormatter" label="下单时间" show-overflow-tooltip></el-table-column>
      <el-table-column label="图片">
        <template slot-scope="scope">
          <img src="../assets/image.png" class="image-btn" @click="viewImage(scope.row)">
        </template>
      </el-table-column>
      <el-table-column prop="checkTime" :formatter="dateFormatter" label="审核时间" show-overflow-tooltip></el-table-column>
      <el-table-column
        label="操作"
        width="200">
        <template slot-scope="scope">
          <el-button v-if="scope.row.status == '待审核'"
            @click.native.prevent="orderPass(scope.row)"
            type="text"
            size="small">
            通过
          </el-button>
          <el-button v-if="scope.row.status == '待审核'"
            @click.native.prevent="orderBack(scope.row)"
            type="text"
            size="small">
            驳回
          </el-button>
          <el-button
            @click.native.prevent="orderDetailView(scope.row)"
            type="text"
            size="small">
            订单详情
          </el-button>
          <el-button
            @click.native.prevent="exportAll(scope.row.id)"
            type="text"
            size="small">
            导出
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.currentPage"
        :page-sizes="[10, 20, 30]"
        :page-size="pageInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageInfo.total">
      </el-pagination>
    </div>
    <el-dialog
      :visible.sync="imageViewDialogVisible"
      width="40%"
      @closed="closeImageViewDialog">
      <span slot="title">
         <el-button size="mini" type="primary" @click="downloadImage">下载</el-button>
      </span>
      <div style="text-align: center">
        <el-image :src="'api/'+orderImage" fit="cover"></el-image>
      </div>
    </el-dialog>
    <el-dialog
      :title="orderDetailTitle"
      :visible.sync="orderDetailDialogVisible"
      width="70%"
      @closed="closeDetailViewDialog">
      <el-row :gutter="20">
        <el-col :span="8">
          <p>顾客姓名:{{orderDetail.seller.nickname}}</p>
          <p>手机号码:{{orderDetail.seller.phone}}</p>
          <p>银行账户:{{orderDetail.account.bankAccount}}</p>
          <p>支付宝账户:{{orderDetail.account.alipayAccount}}</p>
          <p>订单编号:{{orderDetail.order.orderNum}}</p>
          <p>商品名称:{{orderDetail.card.cardName}}</p>
          <p>订单总额:{{orderDetail.order.payMoney}}</p>
          <p>卡券识别号:{{orderDetail.order.cardUnqiueNum}}</p>
        </el-col>
        <el-col :span="8">
          <p>身份证号:{{orderDetail.seller.idCard}}</p>
          <p>用户APPID:{{orderDetail.seller.openId}}</p>
          <p>银行卡号:{{orderDetail.account.bankCardNum}}</p>
          <p>账号姓名:{{orderDetail.account.alipayName}}</p>
          <p>下单时间:{{dateFormatter_s(orderDetail.order.createTime,"yyyy-MM-dd HH:mm:ss")}}</p>
          <p>赠送积分:{{orderDetail.order.awradCredit}}</p>
          <!--<p>是否重复:否</p>-->
          <p>卡券链接:{{orderDetail.order.cardLink}}</p>
        </el-col>
        <el-col :span="8">
          <p>订单状态:{{orderDetail.order.status}}</p>
          <p>购买渠道:{{orderDetail.seller.source}}</p>
          <p>开户行:{{orderDetail.account.bankName}}</p>
          <p>卡券有效期:{{dateFormatter_s(orderDetail.order.validDate)}}</p>
          <p>卡券图片:
            <span v-if="!orderDetail.order.cardImage">没有上传图片</span>
            <img v-if="orderDetail.order.cardImage" :src="'api/'+orderDetail.order.cardImage" style="width: 100px;" @click="viewImage({cardImage:orderDetail.order.cardImage})"/></p>
          <div v-show="action == 'pass'">
            付款金额&nbsp;&nbsp;&nbsp;<el-input v-model="actualPay" type="number" size="mini" style="width:130px" placeholder="请输入付款金额"></el-input>
          </div>
        </el-col>
      </el-row>
      <div v-show="action == 'view'">
        <el-row :gutter="20">
          <el-col :span="12">
            <p>服务满意度：</p>
            <el-rate v-model="orderDetail.comment.rate"></el-rate>
            <p>评价</p>
            <p>{{orderDetail.comment.content}}</p>
          </el-col>
          <el-col :span="12">
            <span>评价展示到客户端</span>
            <el-switch
              v-model="orderDetail.comment.isDisplay"
              active-value="1"
              inactive-value="0"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="isDisplayChange">
            </el-switch>
          </el-col>
        </el-row>
        <div>
          <p>用户留言:<span v-if="messageContentList <= 0">暂无留言</span></p>
          <div v-for="item in messageContentList" :key="item.id">
            <p>{{item.message}}</p>
            <p style="color: #999999;font-size: 12px">{{dateFormatter_s(item.createTime,"yyyy-MM-dd HH:mm:ss")}}更新</p>
          </div>
          <p>留言回复:<span v-if="messageBackList <= 0">暂无回复</span></p>
          <div v-for="item in messageBackList" :key="item.id">
            <p>{{item.message}}</p>
            <p style="color: #999999;font-size: 12px">{{dateFormatter_s(item.createTime,"yyyy-MM-dd HH:mm:ss")}}更新</p>
          </div>
        </div>
        <div>
          商家回复：<el-input type="textarea" v-model="orderDetail.order.merchantBack"></el-input>
          <el-button
            @click.native.prevent="saveMerchantBack()"
            type="primary"
            size="small">
            提交回复
          </el-button>
        </div>
      </div>
      <span v-show="action == 'pass'" slot="footer" class="dialog-footer">
        <el-button @click="closeDetailViewDialog">取 消</el-button>
        <el-button type="primary" @click="orderPassSure">确认打款</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="用户留言"
      :visible.sync="showMessageFlag"
      width="40%">
      <p style="font-weight: bold">留言内容：<span v-if="messageContentList <= 0">暂无留言</span></p>
      <div v-for="item in messageContentList" :key="item.id">
        <p>{{item.message}}</p>
        <p style="color: #999999;font-size: 12px">{{dateFormatter_s(item.createTime,"yyyy-MM-dd HH:mm:ss")}}更新</p>
      </div>

      <p style="font-weight: bold">回复内容：<span v-if="messageBackList <= 0">暂无回复</span></p>
      <div v-for="item in messageBackList" :key="item.id">
        <p>{{item.message}}</p>
        <p style="color: #999999;font-size: 12px">{{dateFormatter_s(item.createTime,"yyyy-MM-dd HH:mm:ss")}}更新</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import utils from "../utils/utils"
  export default {
    name: "order-search",
    data(){
      return {
        searchForm:{
          createTimeRange:null,
          searchType:"order",
          keyWords:"",
          status:"",
          minValidDays:null,
          maxValidDays:null
        },
        tableData:[],
        pageInfo:{
          currentPage:1,
          pageSize:30,
          total:0
        },
        multipleSelection:[],
        selectIds:[],
        searchTypeList:[{
          value:"order",
          label:"订单号"
        },{
          value:"sellerName",
          label:"用户名"
        },{
          value:"cardName",
          label:"商品名"
        }],
        status:0,
        imageViewDialogVisible:false,
        orderDetailTitle:"",
        orderDetailDialogVisible:false,
        defaultHeadPicSrc:require('../assets/person.png'),
        orderDetail:{
          seller:{
            nickname:"",
            idCard:"",
            phone:"",
            openId:"",
            source:""
          },
          order:{
            status:"",
            orderNum:"",
            createTime:"",
            payMoney:"",
            awradCredit:"",
            cardUnqiueNum:"",
            validDate:"",
            cardImage:"",
            cardLink:"",
            userMessage:"",
            merchantBack:""
          },
          account:{
            bankAccount:"",
            bankCardNum:"",
            bankName:"",
            alipayName:"",
            alipayAccount:"",
          },
          comment:{
            id:null,
            rate:0,
            content:"",
            isDisplay:"1"
          },
          card:{
            cardName:""
          }
        },
        actualPay:null,
        action:"",
        statusName:["待审核","待评价","已完成","已驳回"],
        orderId:null,
        orderImage:"",
        showMessageFlag:false,
        messageContentList:"",
        messageBackList:""
      }

    },
    created(){
      this.getData();
    },
    methods:{
      getData(){
        const loading = this.$loading({
          lock: true,
          text: '加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0)'
        });
        utils.axiosMethods({
          method:"POST",
          url:"/api/order/queryOrder",
          params:{
            currentPage:this.pageInfo.currentPage,
            pageSize:this.pageInfo.pageSize
          },
          data:{
            createTimeStart:this.searchForm.createTimeRange?this.searchForm.createTimeRange[0]+" 00:00:00":"",
            createTimeEnd:this.searchForm.createTimeRange?this.searchForm.createTimeRange[1]+" 23:59:59":"",
            keyWord:this.searchForm.keyWords,
            minValidDays:this.searchForm.minValidDays,
            maxValidDays:this.searchForm.maxValidDays,
            status:this.searchForm.status,
            searchType:this.searchForm.searchType
          },
          callback:(res => {
            loading.close();
            res.data.list.map(item => {
              item.messageContentList = item.messageList.filter(item => item.type == "1");
              item.messageBackList = item.messageList.filter(item => item.type == "2");
              return item;
            })
            this.tableData = res.data.list;
            this.pageInfo.total = res.data.total;
          }),
          catch:(err=>{
            loading.close();
          })
        })
      },
      selectOrderStatus(status){
        if(this.status == status){
          return;
        }
        this.status = status;
        if(status == 0){
          this.searchForm.status = ""
        }else if(status == 5){
          this.searchForm.status = "待评价,已完成";
        }else{
          this.searchForm.status = this.statusName[status - 1];
        }

        this.getData();
      },
      //每页展示数据条数改变
      handleSizeChange(val){
        this.pageInfo.pageSize = val;
        this.getData();
      },
      //页码改变
      handleCurrentChange(val){
        this.pageInfo.currentPage = val;
        this.getData();
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
        let ids = [];
        val.map(item => {
          ids.push(item.id)
        });
        this.selectIds = ids;
      },
      // 日期格式化
      dateFormatter(row, column, cellValue, index){
        return utils.dateFormat(cellValue,"yyyy-MM-dd HH:mm:ss")
      },
      dateFormatter2(row, column, cellValue, index){
        return utils.dateFormat(cellValue)
      },
      closeImageViewDialog(){
        this.imageViewDialogVisible = false
        this.orderImage = ""
      },
      //预览图片
      viewImage(row){
        if(row.cardImage){
          this.imageViewDialogVisible = true
          this.orderImage = row.cardImage
        }else{
          this.$message.success("该订单没有上传图片")
        }
      },
      closeDetailViewDialog(){
        this.orderDetailDialogVisible = false;
        this.orderId = null;
      },
      orderDetailView(row){
        this.orderDetailDialogVisible = true;
        this.orderDetailTitle = "订单详细";
        this.action = "view";
        this.orderId = row.id;
        this.getOrderDetail(row.id)
      },
      orderPass(row){
        this.orderDetailTitle = "审核确认";
        this.action = "pass";
        this.getOrderDetail(row.id)
        this.orderId = row.id
      },
      getOrderDetail(orderId){
        utils.axiosMethods({
          method:"GET",
          url:"/api/order/getOrderDetailInfo",
          params:{
            orderId:orderId
          },
          callback:(res => {
            if(res.data.code == 0){
              if(!res.data.obj.comment){
                res.data.obj.comment = {
                  id:null,
                  rate:0,
                  content:"",
                  isDisplay:"1"
                }
              }
              this.orderDetail = res.data.obj;
              this.orderDetail.order.merchantBack = "";
              this.messageContentList = res.data.obj.order.messageList.filter(item => item.type == '1');
              this.messageBackList = res.data.obj.order.messageList.filter(item => item.type == '2');
              if(!res.data.obj.account){
                res.data.obj.account = {
                  bankAccount:"",
                  bankCardNum:"",
                  bankName:"",
                  alipayName:"",
                  alipayAccount:"",
                }
              }
              this.actualPay = res.data.obj.order.payMoney;
              this.orderDetailDialogVisible = true;
            }
          })
        })
      },
      dateFormatter_s(date,str){
        return utils.dateFormat(date,str)
      },
      //确认打款
      orderPassSure(){
        utils.axiosMethods({
          method:"GET",
          url:"/api/order/passOrder",
          params:{
            orderId:this.orderId,
            actualPay:this.actualPay
          },
          callback:(res => {
            if(res.data.code == 0){
              this.$message.success("审核成功")
              this.orderDetailDialogVisible = false
              this.orderId = null
              this.getData();
            }
          })
        })
      },
      //驳回
      orderBack(row){
        utils.axiosMethods({
          method:"GET",
          url:"/api/order/backOrder",
          params:{
            orderId:row.id,
            actualPay:this.actualPay
          },
          callback:(res => {
            if(res.data.code == 0){
              this.$message.success("驳回成功")
              this.getData();
            }
          })
        })
      },
      downloadImage(){
        const path = this.orderImage;
        window.open("/api/order/downloadImg?path="+path,"_parent");
      },
      isDisplayChange(val){
        utils.axiosMethods({
          method:"GET",
          url:"/api/seller/sellerCommentChangeDisplay",
          params:{
            id:this.orderDetail.comment.id,
            isDisplay:val
          },
          callback:(res => {
            if(res.data.code == 0){
              this.$message.success("修改成功")
            }
          })
        })
      },
      exportAll(id){
        const createTimeStart = this.searchForm.createTimeRange?this.searchForm.createTimeRange[0] + " 00:00:00":"";
        const createTimeEnd = this.searchForm.createTimeRange?this.searchForm.createTimeRange[1]+ " 23:59:59":"";
        const keyWord = this.searchForm.keyWords;
        const maxValidDays = this.searchForm.maxValidDays;
        const minValidDays = this.searchForm.minValidDays;
        const status = this.searchForm.status;
        const searchType = this.searchForm.searchType;
        if(id){
          window.open("/api/order/exportOrderToExcelById?id="+id,"_parent");
        }else{
          window.open("/api/order/exportOrderToExcel?createTimeStart="+createTimeStart+"&createTimeEnd="+createTimeEnd
            +"&keyWord="+keyWord+"&status="+status+"&searchType="+searchType+"&maxValidDays="+maxValidDays+"&minValidDays="+minValidDays,"_parent");
        }

      },
      exportImg(){
        const createTimeStart = this.searchForm.createTimeRange?this.searchForm.createTimeRange[0] + " 00:00:00":"";
        const createTimeEnd = this.searchForm.createTimeRange?this.searchForm.createTimeRange[1]+ " 23:59:59":"";
        const keyWord = this.searchForm.keyWords;
        const minValidDays = this.searchForm.minValidDays;
        const maxValidDays = this.searchForm.maxValidDays;
        const status = this.searchForm.status;
        const searchType = this.searchForm.searchType;
        window.open("/api/order/exportOrderImg?createTimeStart="+createTimeStart+"&createTimeEnd="+createTimeEnd
          +"&keyWord="+keyWord+"&status="+status+"&searchType="+searchType+"&minValidDays="+minValidDays+"&maxValidDays="+maxValidDays,"_parent");
      },
      saveMerchantBack(){
        const loading = this.$loading({
          lock: true,
          text: '加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0)'
        });
        utils.axiosMethods({
          method:"POST",
          url:"/api/order/saveMerchantBack",
          data:{
            id:this.orderId,
            content:this.orderDetail.order.merchantBack
          },
          callback:(res => {
            loading.close();
            if(res.data.code == 0){
              this.$message.success("回复成功")
            }else{
              this.$message.error("回复失败")
            }
          }),
          catch:(error => {
            loading.close();
            this.$message.error("回复失败")
          })
        })
      },
      showMessage(row){
        this.showMessageFlag = true;
        if(row.messageList && row.messageList.length > 0){
          this.messageContentList = row.messageList.filter(item => item.type == '1');
          this.messageBackList = row.messageList.filter(item => item.type == '2');
        }
      }
    }
  }
</script>

<style scoped lang="less">
  #orderSearch{
    .block{
      float: right;
      margin-top: 20px;
    }
    .image-btn{
      width: 25px;
      height: 25px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/orderSearch.vue